import React, { Component } from "react";
import { FormattedMessage, injectIntl } from 'react-intl'
import upgradeVip from "./res/phonedownload/upgrade_vip.png"

import { QRCodeSVG } from 'qrcode.react'

import { message } from 'antd';
import Locale from './lang/Locale'

import "./TimeTable.css";
import "antd/dist/antd.min.css";
import "url-search-params-polyfill"

class TimeTable extends Component {

    constructor(props) {

        super(props);

        
        const { intl } = this.props;

        this.state = {
            vipdisplay:'none',
            ioslink:'',
            otherlink:'',
            qrCodeValue:'',
            nickName:'',
            timeTableTitle:''
        };
    }

    componentWillMount() {
        const { intl } = this.props;

        let lang = Locale.Instance.getLang();
        
        var search = new URLSearchParams(window.location.search);
        let code = search.get("code");


        let country = 'us';
        if( lang === 'chs' ) {
            country = 'cn';
        } else if( lang === 'cht' ) {
            country = 'tw';
        } else if( lang === 'kor' ) {
            country = 'kr';
        }

        if (code != null && code != '') {
            var text = '{"type":"timetable_share","value":"' + code + '"}';
            this.setState( { qrCodeValue : text });
            this.getTimeTableInfo(code);
        }

    }

    async getTimeTableInfo(code) {
        
        let retobj = await fetch( 'https://data.xdiarys.com/api/event/v1/getShareInfoByCode?code=' + code, {
            method: "GET",
            credentials: 'include',
            headers: {
            'Accept': 'application/json, text/plain, */*',
            }
        })
        .then(function (response) {
            return  response.json();
        })
        .then((myJson) => {
            return myJson;
        })
        .catch(function (e) {
            console.log( e );
        });

        
        console.log( retobj );
        if( retobj.result === 1 ) {
            this.setState( { nickName : retobj.vdata.user_nickname });
            this.setState( { timeTableTitle : retobj.vdata.timetable_title });
        } else{
            message.error("获取分享信息失败！");
        }
    }

    render() {

        let image_1 = require("./res/timetable/phone-chs.png")
        let timetableImg = require("./res/timetable/timetable.png")  
        let handImg = require("./res/timetable/hand.png")        
        let iosImg = require("./res/timetable/ios.png")        
        let androidImg = require("./res/timetable/android.png")  
        let downImg = require("./res/timetable/download.png")       
        
        let locale = Locale.Instance.getLocal();
        if (locale === 'ko') {
            image_1 = require("./res/phonedownload/kor_1.jpg")
        }
        else if(locale === 'zh-tw' ) {
            image_1 = require("./res/phonedownload/cht_1.jpg")
        }
        else if(locale === 'en' ) {
            image_1 = require("./res/phonedownload/usa_1.jpg")
        }

        return (
            <div className="pdcontainer" >
            <div className="containertitle">
                <div className="ttbar" >
                    <QRCodeSVG id="qrcode" marginSize="3" value={this.state.qrCodeValue} />
                    <div className="titlecontainer mt3" >
                        <div className="tttitle">打开日历清单手机APP，扫描二维码</div>
                        <div className="ttslogn">获取{this.state.nickName}分享的{this.state.timeTableTitle}课程表</div>
                    </div>
                </div>
            </div>

            <div className="container2">
                <div className="screentext"></div>
                <div className="imagescontainer">
                    <div className="tt-left">
                        <img src={image_1} alt="download view1" className="imagelist pr0" />
                    </div>
                    <div>
                        <img src={handImg} alt="download view1" className="imageHand" />
                    </div>
                    <div  className="tt-right">
                        <div  className="tt-text">
                            <div class="textblock" >
                                <div class="blockbkg"></div>
                                <div class="title">点击扫描按钮，扫描上面的二维码</div>
                            </div>
                            <div class="textblock pt2" >
                                <div class="blockbkg"></div>
                                <div class="title">电脑客户端会自动显示出{this.state.timeTableTitle}课程表</div>
                            </div>
                                
                        </div>
                        <div  className="tt-img mt3">
                            <img src={timetableImg} />
                        </div>
                    </div>
                </div>
                <div className="screentext"></div>
            </div>

            <div className="bcontainer h330">
                <div className="ttbar" >
                    <div className="titlecontainer mt3" >
                        <div class="textblock" >
                            <div class="blockbkg"></div>
                            <div class="title size-22">手机版本下载</div>
                        </div>
                        <div className="down-line mt-30">
                            <img className="donw-ico" src={iosImg} /> 苹果手机，请在AppStore搜索<b>日历清单</b>
                        </div>
                        <div className="down-line mt-15">
                            <img  className="donw-ico" src={androidImg} /> 安卓手机，请在应用商店里搜索<b>日历清单</b>
                        </div>
                    </div>
                    <div className="titlecontainer mt-r30" >
                        <img src={downImg} alt="download view1" className="down-img" />
                    </div>
                </div>
                <div className="down-more mt-40">查看手机版更多功能</div>
            </div>

            <div className="bottomcontainer">
                <div className="aboutcontainer">
                    <div className="abouttext">
                        <FormattedMessage id='phodedownload_about' />&nbsp;&nbsp;service@xiaoweiyunfu.com
                    </div>
                </div>
                <div className="copyrighttext">
                    Copyright © Beijing Xiaowei Cloud Service Technology Co., Ltd.&nbsp;&nbsp;&nbsp;&nbsp;<FormattedMessage id='phodedownload_copyright' />
                </div>
            </div>
            </div>
        )
    }
}



export default injectIntl(TimeTable);